const extractElementsFromPopupContent = (popupContent) => {
  const domParser = new DOMParser();
  const doc = domParser.parseFromString(popupContent, 'text/html');

  const scriptCollection = doc.getElementsByTagName('script');
  const scripts = Array.from(scriptCollection);

  const numberOfScripts = scripts.length;
  const tmpScripts = [...scripts];
  for (let i = 0; i < numberOfScripts; i++) {
    const script = tmpScripts[i];
    script.parentNode.removeChild(script);
  }

  const tmp = document.createElement('div');
  tmp.appendChild(doc.body);

  return {
    content: tmp.innerHTML,
    scripts,
  };
};

export default extractElementsFromPopupContent;
